module.exports = __webpack_public_path__ + "img/ningxia.39360683.jpg";